
import { SAFELIGHT_DESCRIPTION } from "@/App";
import { useIsMobile } from "@/hooks/use-mobile";
import { Capacitor } from '@capacitor/core';

export const DescriptionHeader = () => {
  const isMobile = useIsMobile();
  const isNativeApp = Capacitor.isNativePlatform();
  
  // Return empty header on mobile view or if it's running in the native app
  if (isMobile || isNativeApp) {
    return <header className="mb-2 mt-2"></header>;
  }

  return (
    <header className="flex flex-col items-center text-center mb-8 mt-2">
      <p className="max-w-xl text-muted-foreground text-base sm:text-lg text-center mb-2">
        {SAFELIGHT_DESCRIPTION}
      </p>
    </header>
  );
};
